import ReactGA from "react-ga4";
import Visual from "../Visuals/Visual 15.webp";
import commonClasses from "../ArticleStyle.css"
import classes from "./knxsupply.css"
import FatArrow from "../../../containers/UI/FatArrow.svg"

const News = (props) => {

  return (
    <>
      <div className={commonClasses.container}>

        <div className={commonClasses.innerContainer}>
          <h3 className={commonClasses.dateLabel}>Tervuren, May 10th 2025</h3>
          <h1>KNXSupply becomes exclusive US distributor</h1>
          
          <div className={classes.visualContainer}>
            <img src={Visual} className={commonClasses.visual} alt="KNXSupply logo"/>
          </div>

          <p className={commonClasses.contentParagraph}>We're excited to announce that KNXsupply is now the exclusive distributor of the Allorado Gateway in the United States. This partnership marks a key step in expanding Allorado's presence in the U.S. market, making it easier than ever for American integrators to access our cutting-edge LoRa to BACnet, Modbus and KNX solutions.</p>
          <p className={commonClasses.contentParagraph}>For U.S. orders and support, visit <a href="https://knxsupply.com" className={commonClasses.inlineLink} target="_blank" rel="noreferrer">KNXSupply.com</a></p>
          
          <div className={commonClasses.callToAction}>
            <h3>Want to become part of the action?</h3>
            <div className={commonClasses.orderRow}>
              <button className={commonClasses.orderButton} onClick={() => {
                  ReactGA.event({ category: "Button", action: "DistributorBrochure" })
                  window.location = "mailto:sales@allorado.io?subject=Becoming an Allorado distributor"
                }}>Become a distributor</button>
              <img src={FatArrow} className={commonClasses.arrow} alt="arrow"/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default News;
